import { Client } from '@lemonade-hq/nuiza';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import type { PartnerName, PartnerOnboardingResponseType } from '../../../definitions';

export interface PartnerOnBoardingQueryParams {
  readonly partnerName: PartnerName;
  readonly dataSourceId: string;
  readonly token: string;
}

enum PartnerOnBoardingQueryKey {
  PartnerOnboarding = 'PARTNER_ONBOARDING',
}

export async function createPartnerOnboarding({
  partnerName,
  dataSourceId,
  token,
}: PartnerOnBoardingQueryParams): Promise<PartnerOnboardingResponseType> {
  const url = `/partners/onboarding/url?partnerName=${partnerName}&dataSourceId=${dataSourceId}&token=${token}`;

  return await Client.get<PartnerOnboardingResponseType>(url);
}

export const usePartnerOnboarding = ({
  partnerName,
  dataSourceId,
  token,
}: PartnerOnBoardingQueryParams): UseQueryResult<PartnerOnboardingResponseType, unknown> => {
  return useQuery({
    queryKey: [PartnerOnBoardingQueryKey.PartnerOnboarding, { partnerName }],
    queryFn: async () => await createPartnerOnboarding({ partnerName, dataSourceId, token }),
  });
};
